import { render, staticRenderFns } from "./TransferAmount.vue?vue&type=template&id=e5ec084a&"
import script from "./TransferAmount.vue?vue&type=script&lang=js&"
export * from "./TransferAmount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports